import type { ID } from "@constants";
import type { IPhoneNumber } from "@/components/formControls";

export enum IRole {
  SUPER_ADMIN = "super_admin",
  STAFF = "staff",
  DEPARTMENT_STAFF = "departmentStaff",
  FACULTY_MEMBER = "faculty_Member",
  UNKNOWN = "unknown",
}

export enum IUserStatus {
  active = "active",
  inactive = "inactive",
}

export enum INotificationType {
  panel = "panel",
  mail = "mail",
  sms = "sms",
}

export enum ISocialMedia {
  orcid = "orcid",
  // google = "Google",
  // youtube = "Youtube",
  whatsapp = "whatsapp",
  // twitterX = "Twitter_X",
  // threads = "Threads",
  // telegram = "Telegram",
  // skype = "Skype",
  medium = "medium",
  linkedin = "linkedin",
  // instagram = "Instagram",
  github = "github",
  // facebook = "Facebook",
  // discord = "Discord",
}

export interface IOption<T extends string | number = ID> {
  key: T;
  value: string;
}

export type IMetaOption<
  TMeta,
  TOption extends string | number = ID,
> = IOption<TOption> & TMeta;

export const EmptyNumberOption: IOption<number> = { key: 0, value: "" };
export const EmptyOption = { key: "" as const, value: "" as const };
export const EmptyPhone: IPhoneNumber = { code: "+98", number: "" };

export interface IApiMapper<TApi, TData, TDto = TApi, TForm = TData> {
  fromApi: (data: TApi) => TData;
  toApi?: (data: TForm) => TDto;
}

export interface INotNullableFileObject {
  id: ID;
  name: string;
  type: string;
  size: number;
  url: string;
}

export type IFileObject = INotNullableFileObject | undefined | null;

export interface IFile {
  id: ID;
  file: File;
}

export interface IDeleteActionParams {
  onDelete: (id: ID) => Promise<void> | void;
}
export interface IEditActionParams {
  onEdit: (id: ID) => Promise<void> | void;
}

export type IUserFormSteps = "info" | "avatar";
